import React, { useEffect, useState } from 'react';
import cls from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useWeb3React } from '@web3-react/core';
import { resetAppState } from '../../../ducks/app/actions';

interface ITab {
  label: string;
  url: string;
}
export interface ITabs {
  tabs: ITab[];
  className?: string;
}

export const SKTabs: React.FC<ITabs> = (props) => {
  const { tabs, className } = props;
  const location = useLocation();
  const [pathName, setPathName] = useState(location.pathname);
  useEffect(() => {
    setPathName(location.pathname);
  }, [location.pathname]);

  const history = useHistory();
  const dispatch = useDispatch();
  const { account } = useWeb3React();
  const isResolveSwapPage = pathName.includes('resolve');

  if (!account) {
    return null;
  }

  const handleRouteChange = (route: string): void => {
    dispatch(resetAppState());
    history.push(route);
  };
  return (
    <ul className={cls('flex', className)}>
      {tabs &&
        tabs.map((tab, index) => {
          return (
            <li
              className={cls('cursor-pointer text-cloud-500 xs-only:text-center text-base py-2.5', {
                'text-cloud-900 border-b-2 border-cloud-900':
                  pathName.includes(tab.url) || (isResolveSwapPage && tab.url.includes('open')),
                'md-and-below:mr-0.5 lg:mx-2': index !== 0,
              })}
              key={tab.url}
              onClick={(): void => handleRouteChange(tab.url)}
            >
              {tab.label}
            </li>
          );
        })}
    </ul>
  );
};
